export default function Footer() {
  return(
    <div>Built with ❤️ in NYC by <a href='https://fosstodon.org/@linuxfan2718'>Dennis</a>.</div>
  )
}
